module.exports = __webpack_public_path__ + "img/quiz-app-5.4dd598a4.png";